"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confirm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const modal_1 = require("../widgets/modal");
exports.Confirm = {
    content: null,
    title: null,
    active: false,
    yes: () => { },
    no: () => { },
    confirm(content, title = "Etes-vous sûr?") {
        exports.Confirm.content = content;
        exports.Confirm.title = title;
        exports.Confirm.active = true;
        return new Promise((yes, no) => {
            exports.Confirm.yes = yes;
            exports.Confirm.no = no;
            mithril_1.default.redraw();
        });
    },
    view() {
        if (!exports.Confirm.active)
            return undefined;
        return (0, modal_1.modalCard)({
            isActive: exports.Confirm.active,
            onClose: () => { exports.Confirm.active = false; },
            title: exports.Confirm.title,
            content: exports.Confirm.content,
            foot: (0, mithril_1.default)("div", (0, mithril_1.default)("button", { class: "button is-success", onclick: () => { exports.Confirm.active = false; exports.Confirm.yes(); } }, "Oui"), (0, mithril_1.default)("button", { class: "button is-danger", onclick: () => { exports.Confirm.active = false; exports.Confirm.no(); } }, "Non")),
        });
    }
};
